/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_EmptyInputs */

const en_admin_tickets_empty = /** @type {(inputs: Admin_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets`)
};

/**
* | output |
* | --- |
* | "No tickets" |
*
* @param {Admin_Tickets_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_empty = /** @type {((inputs?: Admin_Tickets_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_empty(inputs)
});
export { admin_tickets_empty as "admin.tickets.empty" }